import palette from "../palette";

export default {
  paperWidthSm: {
    width: "100%",
  },
};
